// PostgREST filter-string quoting. Anything that is not a literal goes through
// these before it lands in .or() / .not() / a raw `in.(...)` list: an unquoted
// `,` `(` `)` or `.` lets the value add its own filter clauses.
// src/lib/postgrestFilter.ts is a byte-for-byte mirror (Vite cannot import from
// supabase/functions); src/lib/postgrestFilter.test.mjs fails if they drift.

/** A double-quoted filter value: `\` and `"` are backslash-escaped, the PostgREST way. */
export function quoteFilterValue(value: string): string {
  return `"${value.replace(/[\\"]/g, "\\$&")}"`;
}

/** A quoted `(a,b,c)` list for `in.` / `not.in.`. */
export function quoteFilterList(values: string[]): string {
  return `(${values.map(quoteFilterValue).join(",")})`;
}

/**
 * A quoted `%term%` for `ilike.` with the term matched literally. LIKE's own
 * `\ % _` are escaped; `*` is dropped because PostgREST rewrites it to `%` even
 * inside quotes and has no escape for it. Callers should skip the filter when
 * the term is empty after trimming, or it matches every row.
 */
export function ilikeContainsValue(term: string): string {
  const literal = term.replace(/\*/g, "").replace(/[\\%_]/g, "\\$&");
  return quoteFilterValue(`%${literal}%`);
}
